(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ohana-breadcrumbs"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ohana-results-link')) {
    customElements.define('ohana-results-link', class extends HTMLElement {
      connectedCallback() {
        const anchor = this.querySelector('a');
        if (!anchor || !document.referrer) return;
        try {
          const previous = new URL(document.referrer);
          const isResults = /\/collections\/[^/]+\/?$/.test(previous.pathname) || /\/search\/?$/.test(previous.pathname);
          if (previous.origin === location.origin && isResults) {
            anchor.href = previous.href;
            anchor.hidden = false;
          }
        } catch {}
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ohana-judge-accessibility"] && !Shopify.designMode) return;
  try {
    (() => {
    const config = document.getElementById('ohana-judge-accessibility');
    if (!config) return;
    const translations = JSON.parse(config.textContent);
    const roots = '.jdgm-widget, .jdgm-modal, .jdgm-review-widget-modal, .jdgm-preview-badge';
    const labels = '[aria-label], img[alt], label.jdgm-visually-hidden';
    const observed = new WeakSet();
    const isSpanish = () => /^es(?:-|$)/i.test(document.documentElement.lang);
    const format = (key, values) => translations[key].replace(/__(\w+)__/g, (_, name) => values[name] ?? '');

    const translate = (value) => {
      if (Object.hasOwn(translations, value)) return translations[value];
      let match = value.match(/^Review by (.*), ([\d.]+) out of ([\d.]+) stars(.*)\. Open review\.$/);
      if (match) return format('review', { author: match[1], rating: match[2], total: match[3], product: match[4] });
      match = value.match(/^([\d.]+) out of ([\d.]+) stars$/);
      if (match) return format('stars', { rating: match[1], total: match[2] });
      match = value.match(/^View (.+) product page$/);
      if (match) return format('product', { product: match[1] });
      match = value.match(/^(\d+) star(s)?$/);
      if (match) return format(match[2] ? 'star_plural' : 'star', { rating: match[1] });
      match = value.match(/^Average rating is ([\d.]+) stars$/);
      if (match) return format('average', { rating: match[1] });
      match = value.match(/^([\d.,]+%) \((\d+)\) reviews with (\d+) star rating$/);
      if (match) return format(match[3] === '1' ? 'distribution_one' : 'distribution', { percentage: match[1], count: match[2], rating: match[3] });
      match = value.match(/^Page (\d+)$/);
      if (match) return format('page', { number: match[1] });
      match = value.match(/^(.*) review photo (\d+)$/);
      if (match) return format('photo', { author: match[1], number: match[2] });
      match = value.match(/^(\d+) star review$/);
      if (match) return format('star_review', { rating: match[1] });
      return value;
    };

    const update = (element) => {
      if (!isSpanish() || !element) return;
      for (const attribute of ['aria-label', 'alt']) {
        const current = element.getAttribute(attribute);
        if (!current) continue;
        const translated = translate(current);
        if (translated !== current) element.setAttribute(attribute, translated);
      }
      if (element.matches('label.jdgm-visually-hidden') && element.childElementCount === 0) {
        const current = element.textContent.trim();
        const translated = translate(current);
        if (translated !== current) element.textContent = translated;
      }
    };

    const scan = (root) => {
      if (root.nodeType !== Node.ELEMENT_NODE) return;
      if (root.matches(labels)) update(root);
      root.querySelectorAll(labels).forEach(update);
    };

    const observe = (root) => {
      if (observed.has(root)) return;
      observed.add(root);
      scan(root);
      new MutationObserver((records) => {
        for (const record of records) {
          if (record.type === 'attributes') update(record.target);
          else if (record.type === 'characterData') update(record.target.parentElement);
          else {
            if (record.target.matches?.('label.jdgm-visually-hidden')) update(record.target);
            record.addedNodes.forEach(scan);
          }
        }
      }).observe(root, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['aria-label', 'alt'] });
    };

    const discover = (node) => {
      if (node.nodeType !== Node.ELEMENT_NODE) return;
      if (node.matches(roots)) observe(node);
      node.querySelectorAll(roots).forEach(observe);
    };
    discover(document.body);
    new MutationObserver((records) => {
      for (const record of records) record.addedNodes.forEach(discover);
    }).observe(document.body, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
